import { CustomButton } from '../CustomButton';

interface SwitchButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  color: string;
}

export const SwitchButton = ({
  label,
  isActive,
  onClick,
  color,
}: SwitchButtonProps) => {
  return (
    <CustomButton
      onClick={onClick}
      title={label}
      customColor={isActive ? color : undefined}
      color={isActive ? undefined : 'white'}
      className={`mb-3 w-full ${!isActive ? 'shadow-lg' : ''}`}
    />
  );
};
